var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_2183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#CDD0D5"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 90,
    cy: 90,
    r: 90,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17_2183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.765 29.834V200.883H37.2346V29.834C37.2346 27.7803 38.8999 26.1157 40.9537 26.1157H139.046C141.1 26.1154 142.765 27.7803 142.765 29.834Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 119C118 118.448 118.448 118 119 118H129C129.552 118 130 118.448 130 119V141C130 141.552 129.552 142 129 142H119C118.448 142 118 141.552 118 141V119Z",
    fill: "#3AF2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.714 139.086L125.028 134.457C125.371 134.114 125.714 133.6 125.714 133.086C125.714 132.057 125.029 131.371 124 131.371C122.971 131.371 122.286 132.057 122.286 133.086C122.286 133.6 122.629 134.114 122.971 134.457L122.286 139.086H125.714Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.8 124.171C128.8 126.914 126.571 129.143 123.828 129.143C121.086 129.143 118.857 126.914 118.857 124.171C118.857 121.429 121.086 119.2 123.828 119.2C126.571 119.2 128.8 121.429 128.8 124.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 39.247H52.25C51.1454 39.247 50.25 40.1424 50.25 41.247V107.317C50.25 108.421 51.1454 109.317 52.25 109.317H127.75C128.855 109.317 129.75 108.421 129.75 107.317V41.247C129.75 40.1424 128.855 39.247 127.75 39.247Z",
    fill: "#3AF2AE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_17_2183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.236 85.9807L78.372 57.1231C81.7581 54.8621 85.7353 53.6477 89.8993 53.6477C95.4586 53.6477 100.685 55.8121 104.616 59.7423C108.548 63.6725 110.712 68.898 110.712 74.4562C110.712 78.6192 109.498 82.5954 107.236 85.9807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1821 89.17C71.251 85.2398 69.0861 80.0143 69.0861 74.4562C69.0861 70.1883 70.3639 66.1172 72.7364 62.6774L101.681 91.6152C98.24 93.9871 94.168 95.2647 89.8992 95.2647C84.3398 95.2647 79.1132 93.1001 75.1821 89.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8993 45.736C74.034 45.736 61.1726 58.5944 61.1726 74.4562C61.1726 90.3179 74.034 103.176 89.8993 103.176C105.765 103.176 118.626 90.3179 118.626 74.4562C118.626 58.5944 105.764 45.736 89.8993 45.736ZM75.1821 89.17C71.251 85.2398 69.0861 80.0143 69.0861 74.4562C69.0861 70.1883 70.3639 66.1172 72.7364 62.6774L101.681 91.6152C98.24 93.9871 94.168 95.2647 89.8992 95.2647C84.3398 95.2647 79.1132 93.1001 75.1821 89.17ZM107.236 85.9807L78.372 57.1231C81.7581 54.8621 85.7353 53.6477 89.8993 53.6477C95.4586 53.6477 100.685 55.8121 104.616 59.7423C108.548 63.6725 110.712 68.898 110.712 74.4562C110.712 78.6192 109.498 82.5954 107.236 85.9807Z",
    fill: "#FF4D4F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 90,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 175,
    fill: "white",
    transform: "translate(37 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_17_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8816,
    height: 57.8685,
    fill: "white",
    transform: "translate(61.0593 45.5219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDisabled);
export default __webpack_public_path__ + "static/media/access-disabled.c62f129472257b54abdd93fb9ebf5fc1.svg";
export { ForwardRef as ReactComponent };